<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import DxButton from 'devextreme-vue/button';
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';
import CustomStore from 'devextreme/data/custom_store';
import api from "@/axios";


import {
  DxDataGrid,
  DxColumn,

  DxColumnFixing,
  DxSelection,
  DxExport,
  DxSummary,
  DxTotalItem,
  DxStateStoring,

  DxPager, DxFilterRow, DxRemoteOperations


} from 'devextreme-vue/data-grid';
import Swal from "sweetalert2";
import {getBaseUrl} from "@/helpers/baseUrl";




export default {
  page: {
    title: "",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, DxDataGrid, DxColumn, DxButton,
    DxColumnFixing, DxSelection, DxExport, DxSummary, DxTotalItem, DxStateStoring,
    DxToolbar, DxItem, DxPager,  DxFilterRow, DxRemoteOperations

  },
  data() {

    return {
      title: "Processamento de Documentos",
      items: [
        {
          text: "Fretes",
          href: "/"
        },
        {
          text: "Processamento de Documentos",
          active: true
        }
      ],
      dataList: null,
      dataListSelected: null,
    };
  },
  created() {
    window.addEventListener("scroll", this.windowScroll);
  },
  mounted() {

    console.log('mounted processamento-list_0')
    this.atualizaDataList()

  },



  methods: {

    onRowPrepared(e) {
      if (e.rowType === "data") {
        // console.log('e.data')
        // console.log(e.data)
        if (e.data.procmov === false && e.data.proccte === false) {
          e.rowElement.style =  "background-color: #FFA762"
          e.rowElement.className = e.rowElement.className.replace("dx-row-alt", "dx-row-danger");
        }
      }
    },


    processarDocs(){
      console.log('processarDocs')
      console.log(this.dataListSelected)
      this.loadingList = true

      return api.post(`${getBaseUrl()}api/movsproc`, {
        params: this.dataListSelected
      }).then(response => {
        console.log('response.data')
        console.log(response)

        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Movimento(s) processado(s) com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })

        this.atualizaDataList()

      })


    },


    onRowDblClick(row) {
      console.log('onRowDblClick')
      let idData = row.key
      console.log(idData)
      this.$router.push(`/movimento/editar/${idData}`)
    },



    atualizaDataList(){
      console.log('atualizaDataList')
      this.loadingList = true

      this.dataList = new CustomStore({
        // loadMode: "raw",
        key: "chave",
        load: function(loadOptions) {
          console.log('foixxxxxxxxxxxxxxxxxxxxx')
          console.log(loadOptions)
          return api.get(`${getBaseUrl()}api/movsproc`, {
            params: loadOptions
          }).then(response => {
            console.log('response.data')
            console.log(response)
            return {
              data: response.data[0],
              totalCount: response.data[1],
            }
          })
        }
      })
    },


    onExporting(e){
      console.log('onExporting')
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('plan1');
      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), this.title + '.xlsx');
        });
      });
      e.cancel = true;
    },


    refeFormTable(){
      console.log('refeFormTable')
      this.$refs.dataGridRefKey.instance.state(null);
    },


    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },

  },



};

</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div>

      <DxToolbar>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="refresh"
              hint="Redefinir formatação de tabela para padrão"
              :on-click="refeFormTable"/>
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="check"
              hint="Processar Documentos"
              :on-click="processarDocs"/>
        </DxItem>

        <DxItem
            location="center"
            locate-in-menu="never">
          <div class="toolbar-label"><b>{{ this.title }}</b></div>
        </DxItem>

      </DxToolbar>

    </div>


    <div class="mt-2">

      <DxDataGrid
          key-expr="chave"
          ref="dataGridRefKey"
          :data-source="dataList"
          v-model:selected-row-keys="dataListSelected"
          :show-borders="true"
          :focused-row-enabled="true"
          :column-auto-width="true"
          :show-row-lines="true"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          :allow-selection="false"
          :row-alternation-enabled="true"
          @row-prepared="onRowPrepared"
          @row-dbl-click="onRowDblClick"
          @exporting="onExporting">

        <DxRemoteOperations
            :filtering="true"
            :paging="true"
            :sorting="true"
            :summary="true"
            :grouping="false"
            :group-paging="false"
        />


        <DxColumnFixing :enabled="true"/>
        <DxFilterRow :visible="true" />


        <DxSelection
            mode="multiple"
            select-all-mode="page"/>

        <DxExport
            :enabled="true"
            :allow-export-selected-data="true"/>
        <DxStateStoring
            :enabled="true"
            type="sessionStorage"
            storage-key="storage"/>


        <DxColumn :width="400"
                  :is-row-selectable="false"
                  data-field="chave"
                  caption="Chave"
                  alignment="left"
                  data-type="text"
                  :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                  :allowHeaderFiltering="false">
        </DxColumn>



        <DxColumn
            :width="330"
            caption="Processado"
            alignment="center"
            :allowHeaderFiltering="false">



          <DxColumn
              data-field="procmov"
              caption="Nota Fiscal"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allowHeaderFiltering="false">
            <DxButton
                name="save"
                css-class="my-class"
            />
          </DxColumn>

          <DxColumn
              data-field="proccte"
              caption="CT-e"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allowHeaderFiltering="false"/>

          <DxColumn
              data-field="created_at"
              caption="Data"
              data-type="datetime"
              :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="false"/>



        </DxColumn>






        <DxSummary>

          <DxTotalItem
              column="OrderNumber"
              summary-type="count"/>

          <DxTotalItem
              column="OrderDate"
              summary-type="min"/>

          <DxTotalItem
              column="OrderDate"
              summary-type="max"/>


          <DxTotalItem
              column="SaleAmount"
              summary-type="sum"
              value-format="currency"/>

        </DxSummary>



        <DxPager
            :visible="true"
            :show-page-size-selector="true"
            :allowed-page-sizes="[10, 30, 50, 100]"
            :show-navigation-buttons="true"
            :show-info="true"/>


      </DxDataGrid>


    </div>


  </Layout>
</template>
